import { CircularProgress, Dialog, DialogContent } from "@mui/material";

import Suspense from "@/components/molecules/Suspense";
import { BankAccountInput } from "@/interfaces/talk2pay.iterfaces";
import { T2PayHomeMessages } from "@/messages/platforms/talk2PayHome/t2pay-home.messages";

import BankAccountForm from "../bankAccountCreationForm";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  messages: T2PayHomeMessages;
  isLoading: boolean;
  onSubmit: (values: BankAccountInput) => void;
}

export const BankAccountDialog = ({ onSubmit, isOpen, onClose, messages, isLoading }: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose} sx={{ p: 5 }} fullWidth maxWidth="xl">
      <DialogContent>
        <Suspense isSuspended={isLoading} fallback={<CircularProgress size={50} />}>
          <BankAccountForm messages={messages} onCancel={onClose} onSubmit={onSubmit} />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};
